import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

// Const
import { PATH_MY_ACCOUNT, PATH_NOT_FOUND } from 'routes/paths'

// Use
import useMounted from 'use/mounted'
import useQuery from 'use/query'
import { useHistory, useParams } from 'react-router-dom'

// Notifications slice
import { markAsRead } from 'store/modules/notifications'

// Api
import { getAnnouncementInfo } from 'api/announcement'

// Models
import Announcement from 'models/Announcement'

// Components
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Container from 'ui/Container'
import Skeleton from 'ui/Skeleton'
import Breadcrumb from 'ui/Breadcrumb'
import Footer from 'ui/Footer'
import AnnouncementInfo from 'components/Announcement/AnnouncementInfo'

// Breadcrumb items
const breadcrumbs = [
  {
    label: 'Account & payments',
    path: PATH_MY_ACCOUNT,
  },
  {
    label: 'Announcement',
  },
]

export default function PageAnnouncementView() {
  const dispatch = useDispatch()
  const history = useHistory()
  const isMounted = useMounted()
  const { notificationId } = useQuery()

  // State
  const { announcementId } = useParams()

  // State
  const [loading, setLoading] = useState(false)
  const [announcement, setAnnouncement] = useState(new Announcement())

  useEffect(() => {
    setLoading(true)

    dispatch(markAsRead(notificationId))

    getAnnouncementInfo({ announcementId, notificationId })
      .then((data) => {
        if (isMounted.current) {
          setAnnouncement(data)
        }
      })
      .catch(() => {
        history.replace(PATH_NOT_FOUND)
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [announcementId, dispatch, history, isMounted, notificationId])

  // Render
  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Breadcrumb items={breadcrumbs} />
        <Skeleton loading={loading}>
          <AnnouncementInfo announcement={announcement} />
        </Skeleton>
      </Container>
      <Footer />
    </>
  )
}
